import React, { useContext, useState, useEffect } from 'react';

import {
    Container as MaterialContainer,
    Grid,
} from '@sunwisesoftware/sunwise-ui';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { HeaderContainer, TitleIcon } from 'common/components';
import * as customColumnsSelectors from 'common/modules/customColumns/selectors';
import { LoadingContext } from 'common/utils/contexts';

import addPanelsModal from '../addPanelsModal';
import * as addPanelsModalActions from '../addPanelsModal/actions';

import * as actions from './actions';
import ListItems from './components/ListItems';
import * as selectors from './selectors';

const Container = ({
    isFetchingTableSettings,
    filterPanels,
    handleClickAdd,
    handleClickBulkItems,
    isDownloading,
    isFetchingItems,
    isUploading,
    items,
    paginationItems,
    tableSettings,
}) => {
    const { t } = useTranslation();
    const loadingContext = useContext(LoadingContext);
    const [filterData, setFilterData] = useState({
        orderBy: 'created_at',
        page: 0,
        pageSize: 25,
        searchText: '',
        sortBy: 'desc',
        status: 'active',
    });

    useEffect(() => {
        filterPanels(filterData);
    }, []);

    useEffect(() => {
        if (isEmpty(loadingContext)) return;
        if (isDownloading)
            loadingContext.openLoading(t('Downloading document').concat('...'));
        else loadingContext.closeLoading();
    }, [isDownloading]);

    useEffect(() => {
        if (isEmpty(loadingContext)) return;
        if (isUploading)
            loadingContext.openLoading(t('Loading document').concat('...'));
        else loadingContext.closeLoading();
    }, [isUploading]);

    return (
        <MaterialContainer maxWidth={false}>
            <HeaderContainer>
                <Grid size="grow">
                    <TitleIcon title={t('Panel', { count: 2 })} />
                </Grid>
            </HeaderContainer>
            <ListItems
                filterData={filterData}
                filterItems={filterPanels}
                handleClickAdd={handleClickAdd}
                handleClickBulkItems={handleClickBulkItems}
                isFetching={isFetchingItems || isFetchingTableSettings}
                items={items}
                paginationData={paginationItems}
                setFilterData={setFilterData}
                tableSettings={tableSettings}
            />

            <addPanelsModal.Container
                handleAfterSave={() => filterPanels(filterData)}
            />
        </MaterialContainer>
    );
};

Container.propTypes = {
    isFetchingTableSettings: PropTypes.bool,
    filterPanels: PropTypes.func,
    handleClickAdd: PropTypes.func,
    handleClickBulkItems: PropTypes.func,
    isDownloading: PropTypes.bool,
    isFetchingItems: PropTypes.bool,
    isUploading: PropTypes.bool,
    items: PropTypes.array,
    paginationItems: PropTypes.object,
    tableSettings: PropTypes.array,
};

const mapStateToProps = createStructuredSelector({
    ifFetchingTableSettings: customColumnsSelectors.getIsFetchingTableSettings,
    isDownloading: selectors.getIsDownloading,
    isFetchingItems: selectors.getIsFetchingItems,
    isUploading: selectors.getIsUploading,
    items: selectors.getFetchItemsData,
    paginationItems: selectors.getFetchItemsPagination,
    tableSettings: customColumnsSelectors.getTableSettingsData,
});

const mapDispatchToProps = (dispatch) => ({
    filterPanels: (filterData) => dispatch(actions.filterPanels(filterData)),
    handleClickAdd: () => dispatch(addPanelsModalActions.openModal(true)),
    handleClickBulkItems: (ids, value, filterData, callback) =>
        dispatch(actions.prepareBulkItems(ids, value, filterData, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Container);
